import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "../assets/css/Users.module.css";
import Header from "../components/Header";
import List from "../components/List";
import { BASE_URL } from "../constants/constants";

const Users = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 15;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [totalUsersCount, setTotalUsersCount] = useState(0);
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const getUsers = (page = 1) => {
    const params = {
      page: page,
      limit: itemsPerPage,
    };

    if (firstName) params.firstName = firstName;
    if (lastName) params.lastName = lastName;
    if (phoneNumber) params.phoneNumber = phoneNumber;

    axios
      .get(`${BASE_URL}/v0/users`, {
        headers,
        params,
      })
      .then((response) => {
        setUsers(response.data.result.Users);
        setTotalPages(response.data.result.TotalPages);
        setTotalUsersCount(response.data.result.UsersCount);
      })
      .catch((error) => {
        console.error("There was an error fetching the users!", error);
      });
  };

  useEffect(() => {
    getUsers(currentPage);
  }, [currentPage, firstName, lastName, phoneNumber]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div className={styles.text}>
              Пользователи <span>{totalUsersCount}</span>
            </div>
          </div>
          <div className={styles.searchBlock}>
            <input
              className={styles.search}
              type="text"
              placeholder="Имя"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              className={styles.search}
              type="text"
              placeholder="Фамилия"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <input
              className={styles.search}
              type="text"
              placeholder="+7"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
          <div className={styles.container2}>
            {users.map((el) => (
              <div key={el.id} className={styles.block}>
                <div className={styles.name}>
                  {el.firstName || "Пользователь"}
                </div>
                <div className={styles.box1}>
                  <div className={styles.phone}>{el.phoneNumber}</div>
                  <button
                    onClick={() => navigate(`/user/${el.id}`)}
                    className={styles.adminbtn}
                  >
                    <div className={styles.description}>Подробнее</div>
                    <img
                      className={styles.nexticon}
                      src="/images/Vector.svg"
                      alt="next icon"
                    />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.block1}>
            <div className={styles.paginate}>
              <div className={styles.box3}>
                <img
                  className={styles.paginationicons}
                  src="/images/left.svg"
                  alt="left icon"
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              </div>
              <div className={styles.page}>
                {currentPage} / {totalPages}
              </div>
              <div className={styles.box4}>
                <img
                  className={styles.paginationicons}
                  src="/images/right.svg"
                  alt="right icon"
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
